import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PricingTier } from './response/pricing-tier';

@Injectable({ providedIn: 'root' })
export class PricingService {
   constructor(private http: HttpClient) {}

   getPricingTiers(): Observable<PricingTier[]> {
      return this.http.get<PricingTier[]>(`${environment.apiEndpoint}/pricing/tiers`);
   }
}
